import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function SwipeGallery({ items = [], renderItem, slidesPerView = 1, spaceBetween = 12, className = '' }) {
  return (
    <Swiper
      modules={[Navigation, Pagination, Keyboard]}
      navigation
      pagination={{ clickable: true }}
      keyboard={{ enabled: true }}
      loop={false}
      slidesPerView={slidesPerView}
      spaceBetween={spaceBetween}
      breakpoints={{
        0: { slidesPerView: 1 },
        520: { slidesPerView: Math.min(2, slidesPerView) },
        920: { slidesPerView },
      }}
      className={className}
    >
      {items.map((it, i) => (
        <SwiperSlide key={i}>{renderItem ? renderItem(it, i) : null}</SwiperSlide>
      ))}
    </Swiper>
  );
}
